"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrowCycleStageTabs = GrowCycleStageTabs;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
function GrowCycleStageTabs(props) {
    var stage = props.stage, onStageChange = props.onStageChange;
    var STAGE_TABS = [
        { key: "running", label: "Running" },
        { key: "complete", label: "Complete" },
    ];
    return ((0, jsx_runtime_1.jsx)(react_1.Tabs, { selectedKey: stage, onSelectionChange: function (key) { return onStageChange(key); }, className: "w-fit", children: (0, jsx_runtime_1.jsx)(react_1.Tabs.ListContainer, { children: (0, jsx_runtime_1.jsx)(react_1.Tabs.List, { "aria-label": "Grow cycle stage", children: STAGE_TABS.map(function (stageTab) { return ((0, jsx_runtime_1.jsxs)(react_1.Tabs.Tab, { id: stageTab.key, children: [stageTab.label, (0, jsx_runtime_1.jsx)(react_1.Tabs.Indicator, {})] }, stageTab.key)); }) }) }) }));
}
